import React from 'react';
import { InputAdornment } from '@mui/material';
import IconClear from 'shared/icons/clear';

export function ClearTextInputAdornment({
  position,
  onClick,
}: {
  position: 'start' | 'end';
  onClick: () => void;
}) {
  return (
    <InputAdornment onClick={onClick} position={position}>
      <IconClear onClick={onClick} sizeKey="16x16"></IconClear>
    </InputAdornment>
  );
}
